import { Component } from '@angular/core';
import { PopoverController, NavController, Events, Tabs } from 'ionic-angular';
import { EventCodes } from '../../core/codes';
import { FirebaseData } from '../../providers/firebase-data';
import { UserData } from '../../providers/user-data';
import { Utils } from '../../providers/utils';
import { FeedPage } from '../feed/feed';
import { LoginPage } from '../../modules/account/pages/login/login';
import { PopoverCheckboxSelect } from '../../components/popover-checkbox-select';
import _ from 'lodash';


@Component({
  selector: 'page-events',
  templateUrl: 'events.html',
})

export class EventsPage {

  public newsItems: any;
  public newsCats: any;
  public filteredItems: any;
  public isLoading: boolean = true;

  constructor(
    private nav: NavController,
    private userData: UserData,
    private popoverController: PopoverController,
    private firebaseData: FirebaseData,
    private events: Events) {

    let self = this;
    this.events.subscribe(EventCodes.POPOVER_CHECKBOX_CHANGED, (item)=>{
      //Update checkboxList
      _.extend(_.find(self.newsCats, {key: item.key}), item);
      let selectedCats = _.filter(self.newsCats, {checked: true});

      self.filteredItems = _.filter(self.newsItems, function(item: any){
        let foundCat = _.find(selectedCats, function(cat:any){
          return (_.indexOf(item.value.category, Number(cat.key)) > -1);
        });

        return (foundCat!=null);
      })
    });
  }

  ionViewDidEnter() {
    let self = this;

    self.userData.hasLoggedIn().subscribe((isLoggedIn) => {
      if(!isLoggedIn){        
        let tabs:Tabs = self.nav.parent;
        tabs.select(4);
        self.nav.setRoot(LoginPage);
      }else{
        this.getNewsCats();
        
      }
    });    
  }

  private getNewsCats(){
    var self = this;
    self.isLoading = true;
    self.firebaseData.get('event-category').subscribe(cat_data => {
      self.newsCats = Utils.toArray(cat_data);
      _.each(self.newsCats, function(cat){
        cat.checked = true;
      });

      // Get newsItems
      self.firebaseData.get('events').subscribe(news_data => {
        let _newsItems = Utils.toArray(news_data).reverse(); 
        self.newsItems = _newsItems;
        self.filteredItems = _newsItems;
        self.isLoading = false;
      });
    });
  }

  public formatNum(num){
    if(!num){return "";}
    return Utils.formatNumberToString(num);
  }

  public loadEventDetail(event){
    this.nav.push(FeedPage, {event: event});
    // if(event.value.link.type=='inapp'){
    //   this.nav.push(DynamicPage, {name: event.value.link.url});
    // }else{
    //   window.open(event.value.link.url, '_blank', 'location=no,closebuttoncaption=Close,toolbarposition=top');
    // }
  }

  public presentFilter(ev){
    let popover = this.popoverController.create(PopoverCheckboxSelect, {listName:'Category', items: this.newsCats});

    popover.present({ev: ev});
  }
}


// WEBPACK FOOTER //
// ./src/pages/events/events.ts